import React from 'react'
import { HiChevronDown } from "react-icons/hi";

//components
import TextSmallButton from '../Button/Text/TextSmallButton';

function Navigation() {
    return (
        <div>
            <div className='flex justify-end items-center' style={{ backgroundColor: "#0A041B" }}>
                <div className='flex flex-row space-x-32 justify-ends items-center px-120'>
                    <div className='flex flex-row py-20 space-x-24'>
                        <div>
                            <TextSmallButton
                                name="ONLINE VERIFICATION"
                            />
                        </div>
                        <div>
                            <TextSmallButton
                                name="TRACK YOUR TRANSACTION"
                            />
                        </div>
                        <div>
                            <TextSmallButton
                                name="FIRST-TIME JOBSEEKER"
                            />
                        </div>
                    </div>
                    <div className='text-white'>
                        |
                    </div>
                    <div className='flex flex-row space-x-8 justify-center items-center '>
                        <div>
                            <img src="https://ik.imagekit.io/xomvboztg/nbi-landing/ph-flag.png?updatedAt=1736401802703" alt="Philippine flag" />
                        </div>
                        <TextSmallButton
                            name="TAGALOG"
                            showTrailingIcon={<HiChevronDown />}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Navigation